import React, { useEffect, useMemo, useState } from 'react'
import { Button, Checkbox, Modal, Dropdown, Menu, Image, message } from 'antd'
import { HolderOutlined } from '@ant-design/icons'
import { DraggableArea } from 'react-draggable-tags'
import styles from './index.less'
import { useGetSlotDataList } from '@xiaoduo/plugin_sdk'

interface Props {
  visible: boolean
  onClose: () => void
  onSubmit: (val: string[]) => void
  value: string[]
}

const OPTIONS_MAP = {
  platform: { label: '平台', content: '淘宝' },
  level: { label: '告警等级', content: '初级告警' },
  item: { label: '告警质检项', content: '顾客催促物流' },
  employee: { label: '客服姓名', content: '李娅娅' },
  snick: { label: '客服子账号', content: '木月瑞希尔：橘子' },
  cnick: { label: '顾客昵称', content: '远游' },
  content: { label: '告警打标语句', content: '你们物流好慢啊' },
  dialog: { label: '查看会话', content: '查看会话' },
  superior: { label: '上级姓名', content: '李娅娅' },
  time: { label: '告警时间', content: '2021-01-01 12:00:00' },
  shop_info: { label: '店铺名称', content: '木月瑞希尔' },
  department: { label: '子账号分组', content: '售前组' },
  order: { label: '订单号', content: '1234567890' },
}

export const OLD_DEFAULT_OPTIONS = [
  'platform',
  'level',
  'item',
  'employee',
  'snick',
  'cnick',
  'content',
  'dialog',
]

export const DEFAULT_OPTIONS = ['snick', 'level', 'cnick', 'dialog']

type ListType = {
  id: string
  index: number
  is_selected: boolean
  is_checked: boolean
  name: string
}

const TemplateModal = (props: Props) => {
  const { visible: modalVisible, onClose: modalOnClose, onSubmit, value } = props

  // const orderData = useGetSlotDataList('customOrderField') // 取消插槽，直接写入OPTIONS_MAP
  const [dataList, setDataList] = useState<ListType[]>([
    ...Object.keys(OPTIONS_MAP)
      .map((item) => ({
        id: item,
        index: value.indexOf(item),
        is_selected: value.includes(item),
        is_checked: value.includes(item),
        name: OPTIONS_MAP[item].label,
      }))
      .sort((a, b) => a.index - b.index),
  ])

  const memoizedDataList = useMemo(() => {
    // if (orderData) {
    //   orderData.forEach((item) => {
    //     OPTIONS_MAP[item.id] = { label: item.label || '', content: item.content || '' }
    //   })
    // }
    return Object.keys(OPTIONS_MAP)
      .map((item) => {
        const isInclude = value.includes(item)
        return {
          id: item,
          index: value.indexOf(item),
          is_selected: isInclude,
          is_checked: isInclude,
          name: OPTIONS_MAP[item].label,
        }
      })
      .sort((a, b) => a.index - b.index)
  }, [value])

  useEffect(() => {
    setDataList(memoizedDataList)
  }, [memoizedDataList])

  const [dropdownVisible, setDropdownVisible] = useState(false)

  const checkedList = useMemo(() => dataList.filter((i) => i.is_checked), [dataList])
  const selectValue = useMemo(() => dataList.filter((i) => i.is_selected), [dataList])

  const onCancel = () => {
    modalOnClose()
  }

  const onOk = () => {
    if (checkedList.length === 0) {
      message.warning('请至少选择一个字段')
      return
    }

    const newValue = checkedList.sort((a, b) => a.index - b.index).map((i) => i.id)
    onSubmit(newValue)
    modalOnClose()
  }

  const onDelete = (name: string): void => {
    setDataList((preList) =>
      preList.map((v) => {
        if (v.name === name) {
          return { ...v, is_selected: false, is_checked: false }
        }
        return { ...v }
      })
    )
  }

  const onDrag = (newList: ListType[]): void => {
    setDataList(newList.map((v, i) => ({ ...v, index: i })))
  }

  const renderTags = ({ tag }: { tag: ListType }) => {
    return (
      <div className={styles.checkItem} key={tag.id}>
        <HolderOutlined className={styles.checkItem_dragIcon} />
        <Checkbox
          checked={tag.is_checked}
          onChange={(e) => {
            setDataList((preList) =>
              preList.map((v) => {
                if (tag.name === v.name) {
                  return { ...v, is_checked: e.target.checked }
                }
                return { ...v }
              })
            )
          }}
        />
        <span className={styles.checkItem_text} title={tag.name}>
          {tag.name}
        </span>
        <i
          className={`iconfont icon-cancel ${styles.checkItem_delIcon}`}
          onClick={() => onDelete(tag.name)}
        />
      </div>
    )
  }

  const renderDropdownOverlay = () => {
    return (
      <Menu style={{ width: 320, height: 200, overflowY: 'scroll' }}>
        {dataList.map((item) => (
          <Menu.Item key={item.id}>
            <Checkbox
              checked={item.is_selected}
              onChange={(e) => {
                setDataList((preList) =>
                  preList.map((v) => {
                    if (item.name === v.name) {
                      return { ...v, is_selected: e.target.checked, is_checked: e.target.checked }
                    }
                    return { ...v }
                  })
                )
              }}
            >
              {item.name}
            </Checkbox>
          </Menu.Item>
        ))}
      </Menu>
    )
  }

  return (
    <Modal
      destroyOnClose
      width={830}
      style={{ marginTop: -48 }}
      title={<span className={styles.modalTitle}>消息模板设置</span>}
      visible={modalVisible}
      onOk={onOk}
      onCancel={onCancel}
      maskClosable={false}
    >
      <div className={styles.modalContent}>
        <div className={styles.left}>
          <div className={styles.newsExp}>消息示例</div>

          <div className={styles.leftContent}>
            <div className={styles.avatar}>
              <i
                className="iconfont icon-dongdong-jiqiren"
                style={{ fontSize: 16, color: '#FFF' }}
              />
            </div>
            <div>
              <div className={styles.name}>告警助手</div>
              <Image
                src="https://cdn-static.xiaoduoai.com/xiaoduo-front-ums/permanent/warning-high.png"
                alt="告警等级横幅"
                style={{ borderRadius: '4px 4px 0px 0px' }}
                preview={false}
              />
              <div className={styles.newsContent}>
                {checkedList
                  .map((i) => i.id)
                  .map((i, _, nameList) => {
                    if (!OPTIONS_MAP[i]) return null

                    if (i === 'dialog' && nameList.includes('content')) return null

                    if (i === 'dialog' && !nameList.includes('content')) {
                      return (
                        <a href="#" style={{ color: '#1890FF', marginLeft: 'auto' }}>
                          查看会话
                        </a>
                      )
                    }

                    return (
                      <div className={styles.newsItem}>
                        <span>
                          {OPTIONS_MAP[i].label}：{OPTIONS_MAP[i].content}
                        </span>
                        {i === 'content' && nameList.includes('dialog') && (
                          <a href="#" style={{ color: '#1890FF', marginLeft: 'auto' }}>
                            查看会话
                          </a>
                        )}
                      </div>
                    )
                  })}
              </div>
            </div>
          </div>
        </div>
        <div className={styles.right}>
          <div className={styles.title}>消息内容</div>
          <div style={{ display: 'flex' }}>
            <i style={{ color: '#999' }} className="iconfont icon-info-circle1" />
            <ul style={{ paddingLeft: 26 }}>
              <li className={styles.tip_list} style={{ width: 308 }}>
                <span className={styles.tip_list_text}>
                  为满足更多场景，您可以根据需要进行模版配置，添加/删除字段。
                </span>
              </li>
            </ul>
          </div>
          <div>
            <div className={styles.right_check_list}>
              {/* @ts-ignore */}
              <DraggableArea
                key={JSON.stringify(selectValue)}
                isList
                onChange={onDrag}
                tags={selectValue}
                render={renderTags}
              />
            </div>
            <Dropdown
              trigger={['click']}
              visible={dropdownVisible}
              onVisibleChange={setDropdownVisible}
              overlay={renderDropdownOverlay}
            >
              <Button
                style={{
                  marginTop: 24,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <i className={`iconfont icon-tianjia`} style={{ marginRight: 8 }} />
                添加字段
              </Button>
            </Dropdown>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default TemplateModal
